import React from "react";
import { Container, Col, Row } from "reactstrap";

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Map from "../Component/Map";

const About = () => {
  return (
    <div id="investor" className="investor-container">
      <Header about={true} />

      <Container>
        <Row className="row-content">
          <Col style={{ flexDirection: 'column' }} className="text-clm" lg={6} md={12} sm={12}>
            <p className="title-investment">
              Our Team
              </p>
            <p className="history-text">
              A Kiwi company with an international team across six time zones.
              </p>


          </Col>
          <Col className="img-clm" lg={6} md={12} sm={12}>
            <div className='history-imgs'>
              <Map />
            </div>
          </Col>
        </Row>

        <Row className="row-content">
          <Col style={{ flexDirection: 'column' }} className="text-clm" lg={6} md={12} sm={12}>
            <p className="title-investment">
              Our Mission
              </p>
            <p className="history-text">
              To accelerate global progress in technology.
              We believe what will make the difference is the next generation of AI assisted application development  platform like iRithm.
              </p>
          </Col>
          <Col className="img-clm" lg={6} md={12} sm={12}>
          <img className='history-imgs' src={require('../_assets/image/history/history5.png')} />
          </Col>
        </Row>

        <Row className="row-content">
          <Col className="img-clm" lg={6} md={12} sm={12}>
            <img className='history-imgs' src={require('../_assets/image/history/history1.jpg')} />
          </Col>
          <Col style={{ flexDirection: 'column' }} className="text-clm" lg={6} md={12} sm={12}>
            <p className="title-investment">Our Journey</p>
            <p className="history-text">
              As open-source software became available to support building of advanced self-learning systems, we saw the opportunity to develop a platform using machine learning to accelerate quality application development.
              </p>
          </Col>
        </Row>

        <Row className="row-content">
          <Col className="text-clm" lg={6} md={12} sm={12}>
            <p className="history-text">
              iRithm started as a R&D project on program synthesis and alternative programming languages representations during 2017. As the research continued, the product matured into a platform for application development for mobile, web and desktop.
              </p>
          </Col>
          <Col className="img-clm" lg={6} md={12} sm={12}>
            <img className='history-imgs' src={require('../_assets/image/history/history2.jpg')} />
          </Col>
        </Row>

        <Row className="row-content">
          <Col className="img-clm" lg={6} md={12} sm={12}>
            <img className='history-imgs' src={require('../_assets/image/history/history3.jpg')} />
          </Col>
          <Col className="text-clm" lg={6} md={12} sm={12}>
            <p className="history-text">
              Based on solid theoretical foundation in programming languages design and machine learning and years of efforts, our programming language iRExt is a transpiled declarative language that supports virtual actor model and machine learning algorithms weaved to the language.
              </p>
          </Col>
        </Row>

        <Row className="row-content">
          <Col className="text-clm" lg={6} md={12} sm={12}>
            <p className="history-text">
              As the platform evolved and got smarter –  we realized that this solution was delivering not only a platform but an essential resource to help businesses build solutions faster.
              </p>
          </Col>
          <Col className="img-clm" lg={6} md={12} sm={12}>
            <img className='history-imgs' src={require('../_assets/image/history/history4.jpg')} />
          </Col>
        </Row>

        <p style={{ textAlign: 'center' }} className="history-text">
          So, iRithm, the AI assistant for application development, enhanced by machine-learning, was born.
        </p>
      </Container>
      <Footer />
    </div>
  );
}

export default About;